export default __webpack_public_path__ + "img/tobi.609353c8.jpeg";